/* ============================================================
KENSONS CUSTOM – Dynamic strike price (14%) for Zepto live price
Zepto price = ORIGINAL (compare-at). We compute SALE price below it.
Only runs when .kensons-dynstrike exists on the page
============================================================ */

(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function parseEuroToCents(text) {
    const cleaned = (text || "")
      .replace(/\s/g, "")
      .replace(/[^\d.,]/g, "");

    if (!cleaned) return null;

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    let normalized = cleaned;

    if (lastComma > lastDot) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else {
      normalized = normalized.replace(/,/g, "");
    }

    const value = Number(normalized);
    if (Number.isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function formatCentsToEuro(cents) {
    const euros = (cents / 100).toFixed(2);
    const parts = euros.split(".");
    const intPart = parts[0];
    const decPart = parts[1];
    const intWithThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${intWithThousands},${decPart} €`;
  }

  function findPriceEl() {
    const selectors = [
      ".product__price .money",
      ".product__price .price .money",
      ".price .money",
      ".price-item--sale",
      ".price-item--regular",
      "[data-product-price]"
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.textContent && el.textContent.trim()) return el;
    }

    // fallback: first element that looks like a € price
    const candidates = Array.from(document.querySelectorAll("span,div"))
      .filter((n) => n.textContent && n.textContent.includes("€"))
      .slice(0, 80);

    return candidates[0] || null;
  }

  function ensureUi(priceEl, discountPercent) {
    if (!priceEl) return null;

    const existing = document.querySelector(".kensons-dyn-price");
    if (existing) return existing;

    const wrapper = document.createElement("div");
    wrapper.className = "kensons-dyn-price";

    const compare = document.createElement("span");
    compare.className = "kensons-dyn-compare";

    const now = document.createElement("span");
    now.className = "kensons-dyn-now";

    const save = document.createElement("span");
    save.className = "kensons-dyn-save";
    save.textContent = `Du sparst ${discountPercent}%`;

    priceEl.parentNode.insertBefore(wrapper, priceEl);

    wrapper.appendChild(compare);
    wrapper.appendChild(now);
    wrapper.appendChild(save);

    // Hide original price to avoid duplicates
    priceEl.style.display = "none";

    return wrapper;
  }

  function update(discountPercent) {
    const anchor = document.querySelector(".kensons-dynstrike");
    if (!anchor) return;

    const priceEl = findPriceEl();
    if (!priceEl) return;

    const originalCents = parseEuroToCents(priceEl.textContent);
    if (originalCents == null) return;

    // Zepto price is ORIGINAL (compare-at)
    const saleCents = Math.round(originalCents * (1 - discountPercent / 100));

    const ui = ensureUi(priceEl, discountPercent);
    if (!ui) return;

    ui.querySelector(".kensons-dyn-compare").textContent = formatCentsToEuro(originalCents);
    ui.querySelector(".kensons-dyn-now").textContent = formatCentsToEuro(saleCents);
  }

  function observe(discountPercent) {
    const obs = new MutationObserver(() => {
      window.requestAnimationFrame(() => update(discountPercent));
    });

    obs.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  ready(function () {
    const anchor = document.querySelector(".kensons-dynstrike");
    if (!anchor) return;

    const discountPercent = Number(anchor.getAttribute("data-dynstrike") || "14") || 14;

    update(discountPercent);
    observe(discountPercent);
  });
})();
